import { useEffect, useRef } from 'react'
import { CAMPAIGN_HASH } from '../routes'

const PART_ONE_MODEL_URL =
  'https://sketchfab.com/3d-models/tesla-model-x-part-1-b69c8d8f607e4822b93eaf277bd36588'
const PART_TWO_MODEL_URL =
  'https://sketchfab.com/3d-models/tesla-model-x-part-2-6909a6bd5948474a9832482fbc38c47a'
const CREATOR_URL = 'https://sketchfab.com/Number1FanGuy98'
const LICENSE_URL = 'https://creativecommons.org/licenses/by/4.0/'

export function CreditsPage() {
  const headingRef = useRef<HTMLHeadingElement>(null)

  useEffect(() => {
    headingRef.current?.focus()
  }, [])

  return (
    <main className="credits-page" id="main-content">
      <div className="credits-page__shell">
        <a className="credits-page__back" href={CAMPAIGN_HASH}>
          Back to campaign
        </a>

        <header className="credits-page__header">
          <p className="credits-page__eyebrow">Project information</p>
          <h1 className="credits-page__title" ref={headingRef} tabIndex={-1}>
            Credits
          </h1>
          <p className="credits-page__lede">
            Source, license, and modification details for the interactive
            vehicle used by Million Dollar Model X.
          </p>
        </header>

        <div className="credits-page__sections">
          <section
            className="credits-page__section"
            aria-labelledby="credits-vehicle-title"
          >
            <h2 id="credits-vehicle-title">3D vehicle</h2>
            <p>
              <cite>Tesla Model X (Part 1)</cite> and{' '}
              <cite>Tesla Model X (Part 2)</cite> by{' '}
              <a href={CREATOR_URL}>
                BIG FAN 3D '92 NICE MODELS (@Number1FanGuy98)
              </a>
              . View the{' '}
              <a href={PART_ONE_MODEL_URL}>
                original Part 1 model on Sketchfab
              </a>{' '}
              and the{' '}
              <a href={PART_TWO_MODEL_URL}>
                original Part 2 model on Sketchfab
              </a>
              . Part 1 provides the closed-door view, and Part 2 provides the
              open-door view.
            </p>
            <p>
              Both models are licensed under the{' '}
              <a href={LICENSE_URL}>
                Creative Commons Attribution 4.0 International license (CC BY
                4.0)
              </a>
              . Use here does not imply endorsement by the creator.
            </p>
          </section>

          <section
            className="credits-page__section"
            aria-labelledby="credits-modifications-title"
          >
            <h2 id="credits-modifications-title">Modifications</h2>
            <p>
              Owner-supplied source revisions and the native GLB revisions
              converted by Sketchfab were evaluated and adapted for Million
              Dollar Model X. Badges, custom plates, broken-image artifacts,
              redundant geometry, and duplicate windshield geometry were
              removed. The vehicles were optimized, recolored, and relit for an
              interactive web presentation, with open- and closed-door
              derivatives prepared for the vehicle viewer.
            </p>
          </section>

          <section
            className="credits-page__section"
            aria-labelledby="credits-status-title"
          >
            <h2 id="credits-status-title">Campaign status</h2>
            <div className="credits-page__notice">
              <p>
                Placement inventory has not been mapped to the physical vehicle
                or published for sale. Any numbered markers, coordinates,
                prices, or sponsor records used in this prototype are
                illustrative fixture data.
              </p>
              <p>
                The vehicle visuals are creative renderings, not physical wrap
                templates, engineering drawings, or sensor-clearance guidance.
              </p>
            </div>
          </section>

          <section
            className="credits-page__section"
            aria-labelledby="credits-independence-title"
          >
            <h2 id="credits-independence-title">Independent project</h2>
            <p>
              Million Dollar Model X is an independent owner project. It is not
              affiliated with, sponsored by, authorized by, or endorsed by
              Tesla, Inc., Carvana, Sketchfab, or the model creator. Tesla and
              Model X are trademarks of Tesla, Inc.
            </p>
          </section>
        </div>
      </div>
    </main>
  )
}
